import React from "react";
import "../css/soft.css";
import { Helmet } from "react-helmet-async";
import ImageSlider from "./ImageSlider";
import HighlightSoftware from "./HighlightSoftware";
import Header from "./Header";

const ManagementSoft = () => {
  return (
    <div className="bg-white"> {/* Clean stacking */}
      <Helmet>
        <title>Advanced Slot Management Software for Land-Based Casinos</title>
        <meta
          name="description"
          content="Enhance your casino operations with our advanced slot management software, offering real-time analytics, game monitoring, and seamless integration."
        />
      </Helmet>

      {/* Header */}
      <div className="w-full z-10 bg-white relative">
        <Header />
      </div>

      {/* Slider */}
      <div className="w-full my-10">
        <ImageSlider />
      </div>

      {/* Highlight Section */}
      <div className="mx-auto bg-[#eeeeee] sm:px-24 px-4 py-10">
        <HighlightSoftware />
      </div>
    </div>
  );
};

export default ManagementSoft;
